import { Component } from '@angular/core';

import { CaArea } from '../../../core';
import { destroyNewMyFocusPhraseHandle } from '../../function/destroy-handle.function';
import { setFocusPhrase } from '../../function/set-focus-phrase.function';
import { MyFocus } from '../../state.model';

@Component({
    selector: 'cmps-ca-evaluation-new-my-phase',
    templateUrl: './new-my-phase.component.html',
})
export class NewMyPhaseComponent {
    /** @private */
    _key: string;

    /** @private */
    _parentValue: CaArea;

    /** @private */
    _value: MyFocus;

    constructor() {
        this._value = {
            focus: null,
            phrase: null,
        };
    }

    /** @private */
    _onCancelClick(): void {
        destroyNewMyFocusPhraseHandle(this._key);
    }

    /** @private */
    _onSaveClick(): void {
        if (
            this._value.phrase == null ||
            this._value.phrase.trim().length === 0
        ) {
            return;
        }
        setFocusPhrase(this._parentValue, this._value.phrase);
        destroyNewMyFocusPhraseHandle(this._key);
    }
}
